module.exports = __webpack_public_path__ + "static/Catch-f1af7208acf2b3b2d66135b37749bb81.ogv";